export const version = '0.0.0';
export const buildTime = 'Wed Sep 30 2026 17:51:29 GMT+0200 (Central European Summer Time)';
export const sourceUrl = 'https://github.com/CentreForDigitalHumanities/fg-ai/tree/1b68b370b4cc0c883274a785d31a312a7b2db066';
